module.exports = __webpack_public_path__ + "img/16.50d64b39.png";